module.exports = __webpack_public_path__ + "media/images/promo/ebt-logo-ba6ecd4a4a66a1daf2c407c681f0a161d7903b5e0b2168208de66860af53e57f.png";